import {
  keysIndicatorsObject,
  PropertyFormSchema
} from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import useFormStatusIndicator from "../../../../../property-header-form/hooks/useFormStatusIndicator";

export const useErrorsFromMinimalFieldIa = () => {
  const { formattedErrors } = useFormStatusIndicator({
    schema: PropertyFormSchema,
    fieldNames: keysIndicatorsObject.minimalFieldToGenerateSeo
  });

  const getErrors = () => {
    return formattedErrors;
  };

  return { getErrors };
};
